(function ($) {

    function scrollTop() {
        if ($(this).scrollTop() > 1000) {
            $('.up').addClass('show').removeClass('hide');
        } else {
            $('.up').removeClass('show').addClass('hide');
            $('.up').removeClass('hide-btn');
        }
    }

    function set_scrollTop() {
        if ($('footer').length > 0) {
            var footer_offset = $('footer  .container').offset().left;
            var row_width = $('footer .row-wrap').width();
            var we_total = footer_offset + row_width - 35;
            $('footer .up').css('left', we_total + 'px');
            var footer_height = $('footer').outerHeight() - 25 + 'px';
            $('footer .up').css('bottom', footer_height);
        }
    }

    $(document).ready(function () {
        $("footer .social-icon a").append("<span  class='text-hide'>Visit</span>");
        if ($('.up').length > 0) {
            set_scrollTop();
        }
    });

    $(window).on('resize', function () {
        if ($('.up').length > 0) {
            set_scrollTop();
        }
    });

    $(window).on('load', function () {
        if ($('.up').length > 0) {
            set_scrollTop();
        }
        $('footer .copyright').prepend('<div class="copy-col"></div>');
        $('footer .copyright p').appendTo('.copy-col');
    });

    $(window).on("scroll", function () {
        scrollTop();
    });

    $(document).ready(function () {
        // $(".link-more span").click(function () {
        //     $(this).parent().toggleClass("expanded");
        // });

        scrollTop();
        $(document).on('click', 'footer .up', function () {
            $('html, body').animate({'scrollTop': "0"}, 800);
            $('.up').addClass('hide-btn');
        });


    });


  (function() {
    window.dataLayer = window.dataLayer || [];
    document.addEventListener('DOMContentLoaded', function() {

      // push parent tab click event
      function pushParentTab(category, url) {
        window.dataLayer.push({
          event: 'myhoover_tab_click',
          event_category: category || 'Unknown', // 
          event_label: 'MyHoover Feed Tab Navigation', // 
          event_url: url || window.location.href
        });
      }
      

      // push checkbox event
      function pushCheckboxEvent(parentCategory, fellowName, parentUrl, checked) {
        window.dataLayer.push({
          event: 'myhoover_checkbox_click',
          event_category: parentCategory || 'Unknown',
          event_label: fellowName || 'Unknown',  
          parent_url: parentUrl || window.location.href,
          checked: checked
        });
      }
      

      // Track parent tab clicks
      document.querySelectorAll('.feed-tab .search-tabs li.link-contant a.my-hoover-next-btn').forEach(function(linkEl) {
        linkEl.addEventListener('click', function(ev) {
          var tabLi = this.closest('li.link-contant');
          var category = tabLi && tabLi.querySelector('h6') ? tabLi.querySelector('h6').innerText.trim() : 'Unknown';
          var url = this.getAttribute('href') || window.location.href;
          pushParentTab(category, url);
        });
      });

      // Event delegation for checkbox changes (so that dynamically added checkboxes are also captured)
      document.body.addEventListener('change', function(ev) {
        var target = ev.target;
        if (!target.matches('input[type="checkbox"]')) return;

        var checked = target.checked;

        // Find active parent tab
        var activeTabEl = document.querySelector('.feed-tab .search-tabs li.link-contant.active-hover');
        var parentCategory = activeTabEl && activeTabEl.querySelector('h6') ? activeTabEl.querySelector('h6').innerText.trim() : 'Unknown';
        var parentUrl = (activeTabEl && activeTabEl.querySelector('a.my-hoover-next-btn') && activeTabEl.querySelector('a.my-hoover-next-btn').getAttribute('href'))
                        || window.location.href;

        var childId = target.getAttribute('data-id') || target.id || 'Unknown';
        var childName = target.getAttribute('data-name')
                        || (target.nextElementSibling ? target.nextElementSibling.innerText.trim() : '')
                        || 'Unknown';

        // // push a parent tab event — only if you want to also track that when checkbox is selected
        // pushParentTab(parentCategory, parentUrl);

        // // Push checkbox event, with checked state
        // pushCheckboxEvent(parentCategory, childId, parentUrl, checked);

        // Find the fellow name
        var contentWrap = target.closest('.content');
        var fellowNameEl = contentWrap ? contentWrap.querySelector('.fellow-title h6') : null;
        var fellowName = fellowNameEl ? fellowNameEl.innerText.trim() : 'Unknown';

        // OPTIONAL: keep data-id too
        var fellowId = target.getAttribute('data-id') || target.id || 'Unknown';

        // Track parent tab
        pushParentTab(parentCategory, parentUrl);

        // Push checkbox event using fellow name
        pushCheckboxEvent(parentCategory, fellowName, parentUrl, checked);

      });

    });
  })();


  
  


})(jQuery);
